// Allows filtering undefined entries out of an array and retaining typing without an explicit cast
export const isDefined = ((value) => value !== undefined) as <T>(value: T | undefined) => value is T;

export const average = (arr: number[]): number => arr.reduce((sum, curr) => sum + curr, 0) / arr.length;

export const uniqueFilter = (value: any, index: number, self: any[]): boolean => {
  return self.indexOf(value) === index;
};

export const uniqueFilterByProperty =
  (mapper: (item: any) => any) =>
  (value: any, index: number, self: any[]): boolean =>
    self.map(mapper).indexOf(mapper(value)) === index;

export const enforceType: <T>(value: T) => T = (value) => value;

export const prioritizeValue = (items: string[], valueToPrioritize: string): string[] => {
  return items.reduce<string[]>((acc, curr) => {
    return curr === valueToPrioritize ? [curr, ...acc] : [...acc, curr];
  }, []);
};
